import dayjs from 'dayjs';
import classNames from 'classnames';
import { User } from '@Types/index';

import { NotificationData } from '@Types/api/notifications';

import styles from './notification-card.module.css';

function getFormattedDate(time: Date): string {
  const date = dayjs(time);
  const now = dayjs();
  const yesterday = dayjs().subtract(1, 'day');
  const minutes = now.diff(date, 'minute');

  if (minutes < 2) return 'Now';

  if (now.isSame(date, 'day')) return `Today, ${date.format('hh:mm A')}`;

  if (yesterday.isSame(date, 'day'))
    return `Yesterday, ${date.format('hh:mm A')}`;

  return date.format('MM/DD/YYYY, hh:mm A');
}

interface NotificationCardProps {
  isRead: boolean;
  data: NotificationData;
  receivedTime: Date;
  currentUser: User;
  onclick: () => void;
  oncancel: () => void;
  onSearchTask: (recordId: string | number, approveFormPath: string) => void;
}

const mapRequestType = (requestTypeName: string): string => {
  switch (requestTypeName) {
    case 'Requisition':
      return 'MRRequest';
    case 'IT Requisition':
      return 'ITRequisition';
    default:
      return requestTypeName;
  }
};

const NotificationCard: React.FC<NotificationCardProps> = ({
  isRead = false,
  onclick,
  oncancel,
  onSearchTask,
  currentUser,
  data: { requestTypeName, taskId, requestId, eventType, approverEmail },
  receivedTime,
}) => {
  const formattedDate = getFormattedDate(receivedTime);

  const serviceType = requestTypeName === 'Requisition' ? 'mr' : 'ess';

  const requestType = mapRequestType(requestTypeName);

  const pathToApproveForm = `${serviceType}/approvals/task/${taskId}/${requestId}/${requestType}/approve-form`;

  const handleClickRequestLink = (): void => {
    onSearchTask(requestId, pathToApproveForm);
    oncancel();
  };

  return (
    <div
      className={classNames(
        styles.notification,
        !isRead ? styles.unread : null
      )}
      onClick={onclick}
    >
      {approverEmail !== currentUser.email ? (
        <div className={styles.text}> Your Request is Approved!</div>
      ) : (
        <div className={styles.text}>
          You have a new
          {eventType.toLocaleLowerCase() === 'created' ||
          eventType.toLocaleLowerCase() === 'next_stage' ? (
            <span
              className={styles.notifyLink}
              onClick={handleClickRequestLink}
            >
              request
            </span>
          ) : (
            ' request '
          )}
          that requires your attention
        </div>
      )}

      <div className={styles.info}>
        <div>{formattedDate}</div>
        <div className={styles.divider} />
        <div>{requestTypeName}</div>
      </div>
    </div>
  );
};

export default NotificationCard;
